// import Mock from 'mockjs'
const Mock = require('mockjs')

const Random = Mock.Random

// 用户列表
const users = [
  {
    id: 1,
    username: 'admin',
    password: '123456',
    name: '管理员',
    avatar: Random.image('100x100', '#4A7BF7', 'Admin'),
    email: 'admin@example.com',
    role: 'admin',
    permissions: ['*']
  },
  {
    id: 2,
    username: 'manager',
    password: '123456',
    name: '部门经理',
    avatar: Random.image('100x100', '#50CF89', 'Manager'),
    email: 'manager@example.com',
    role: 'manager',
    permissions: ['view', 'edit']
  },
  {
    id: 3,
    username: 'staff',
    password: '123456',
    name: '普通员工',
    avatar: Random.image('100x100', '#F7BA4A', 'Staff'),
    email: 'staff@example.com',
    role: 'staff',
    permissions: ['view']
  }
]

// 符合mock系统要求的格式
module.exports = {
  name: 'User API',
  routes: [
    {
      url: '/api/user/login',
      method: 'post',
      response: config => {
        const { username, password } = config.body
        const user = users.find(user => user.username === username && user.password === password)
        
        if (user) {
          return {
            code: 200,
            data: {
              token: `token-${user.id}-${new Date().getTime()}`,
              userId: user.id
            },
            message: '登录成功'
          }
        } else {
          return {
            code: 400,
            message: '用户名或密码错误'
          }
        }
      }
    },
    {
      url: '/api/user/info',
      method: 'get',
      response: config => {
        // 从 query 参数或 token 中获取 userId
        const token = config.url.split('?')[1]?.split('=')[1] || ''
        let userId = 1 // 默认返回管理员

        if (token) {
          const tokenParts = token.split('-')
          if (tokenParts.length > 1) {
            userId = parseInt(tokenParts[1])
          }
        }
        
        const user = users.find(user => user.id === userId)
        
        if (user) {
          // 移除敏感信息
          const { password, ...userInfo } = user
          
          return {
            code: 200,
            data: userInfo,
            message: '获取成功'
          }
        } else {
          return {
            code: 401,
            message: '用户不存在或登录已过期'
          }
        }
      }
    },
    {
      url: '/api/user/logout',
      method: 'post',
      response: () => {
        return {
          code: 200,
          message: '登出成功'
        }
      }
    }
  ]
} 